// extracted by mini-css-extract-plugin
export default {"actions":"Actions_actions__ZQsRi"};